var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H13C13.6 2 14 1.6 14 1C14 0.4 13.6 0 13 0H5C4.4 0 4 0.4 4 1C4 1.6 4.4 2 5 2Z",
    fill: "#393B48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5H5C4.4 5 4 5.4 4 6C4 6.6 4.4 7 5 7H13C13.6 7 14 6.6 14 6C14 5.4 13.6 5 13 5Z",
    fill: "#393B48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H5C4.4 10 4 10.4 4 11C4 11.6 4.4 12 5 12H13C13.6 12 14 11.6 14 11C14 10.4 13.6 10 13 10Z",
    fill: "#393B48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z",
    fill: "#393B48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1.55228 7 2 6.55228 2 6C2 5.44772 1.55228 5 1 5C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7Z",
    fill: "#393B48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1.55228 12 2 11.5523 2 11C2 10.4477 1.55228 10 1 10C0.447715 10 0 10.4477 0 11C0 11.5523 0.447715 12 1 12Z",
    fill: "#393B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientDashboard);
export default __webpack_public_path__ + "static/media/clientDashboard.d6b24cc2a58d9984bc43e553c0d102f4.svg";
export { ForwardRef as ReactComponent };